/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface InvitationUrlResponse
 */
export interface InvitationUrlResponse {
  /**
   *
   * @type {string}
   * @memberof InvitationUrlResponse
   */
  invitationUrl: string;
}

/**
 * Check if a given object implements the InvitationUrlResponse interface.
 */
export function instanceOfInvitationUrlResponse(
  value: object,
): value is InvitationUrlResponse {
  if (!("invitationUrl" in value) || value["invitationUrl"] === undefined)
    return false;
  return true;
}

export function InvitationUrlResponseFromJSON(
  json: any,
): InvitationUrlResponse {
  return InvitationUrlResponseFromJSONTyped(json, false);
}

export function InvitationUrlResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvitationUrlResponse {
  if (json == null) {
    return json;
  }
  return {
    invitationUrl: json["invitationUrl"],
  };
}

export function InvitationUrlResponseToJSON(json: any): InvitationUrlResponse {
  return InvitationUrlResponseToJSONTyped(json, false);
}

export function InvitationUrlResponseToJSONTyped(
  value?: InvitationUrlResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    invitationUrl: value["invitationUrl"],
  };
}
